import { statList } from "@/mocks/homeContent";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20illustrative%20dusk%20city%20skyline%20with%20layered%20silhouettes%2C%20warm%20amber%20and%20deep%20terracotta%20gradient%20sky%2C%20soft%20glowing%20sun%20near%20the%20horizon%2C%20abstract%20geometric%20buildings%2C%20minimal%20flat%20poster%20art%20style%2C%20calm%20evening%20mood%2C%20editorial%20vector%20aesthetic%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=heyl-6pm-hero&orientation=landscape"
          alt="傍晚六点的城市剪影，暖色调天空"
          title="黑料六点 傍晚爆料 晚间吃瓜"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45" />

      <div className="relative z-10 flex min-h-[560px] w-full flex-col justify-center px-4 py-16 md:min-h-[660px] md:px-8 md:py-24">
        <div className="mx-auto w-full max-w-page">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/15 px-3.5 py-1.5 text-xs text-background-50 backdrop-blur-sm md:text-sm">
              <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-primary-300" />
              今天 18:00 · 傍晚新料已上新 12 条
            </span>

            <h1 className="mt-5 font-heading text-3xl font-semibold leading-tight text-background-50 md:mt-6 md:text-[52px] md:leading-[1.15]">
              黑料六点
              <br />
              傍晚的料，六点准时上桌
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
              傍晚六点是吃瓜高峰期，我们把傍晚新料和晚间吃瓜内容都集中在这里。
              下班路上、晚饭桌旁都能顺手看，前后对比、当事人回应和网友评论一条条排好，
              点开一条就能接上最近的瓜。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#wall"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:text-base"
              >
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-fire-line text-lg" />
                </span>
                看今晚新料
              </a>
              <a
                href="#download"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 md:text-base"
              >
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-download-2-line text-lg" />
                </span>
                下载 App 随时吃瓜
              </a>
            </div>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-4">
            {statList.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-50/20 bg-background-50/10 px-4 py-3 backdrop-blur-sm md:px-5 md:py-4"
              >
                <p className="font-heading text-xl font-semibold text-background-50 md:text-2xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-xs text-background-100/80 md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}